var $6fde75954cba9d3a$exports = {};
// A role="status" region is announced when what it holds changes, never when
// it is inserted already holding it, and Elm inserts an alert whole. So what is
// seen and what is announced are split. Elm's children carry no live role; the
// region is a visually hidden span in the shadow root, empty on connect and
// filled with the [data-status-message] text afterwards. It lives in the shadow
// root because Elm patches the children by position and an extra one would
// throw that off. Only marked text is copied so the dismiss button's name is
// not read out with the message, and unchanged text is not rewritten so it is
// not repeated.
//
// The first copy waits two frames: when the element was inserted outside an
// animation frame, the first callback runs before that frame is rendered, and
// the empty region would never reach the accessibility tree.
//
// The span keeps its text when a keyed Elm list moves the element by
// reinserting it, so a message that was already heard is not heard again.
const $6fde75954cba9d3a$var$MESSAGE = '[data-status-message]';
const $6fde75954cba9d3a$var$FRAMES = 2;
const $6fde75954cba9d3a$var$SHADOW = `
  <style>
    :host { display: block; }
    [role="status"] {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
  </style>
  <slot></slot>
  <span role="status"></span>
`;
function $6fde75954cba9d3a$var$afterFrames(count, callback) {
    let frame;
    const wait = (left)=>{
        frame = requestAnimationFrame(()=>left > 1 ? wait(left - 1) : callback());
    };
    wait(count);
    return ()=>cancelAnimationFrame(frame);
}
class $6fde75954cba9d3a$var$ElmAnnouncement extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        }).innerHTML = $6fde75954cba9d3a$var$SHADOW;
        this.region = this.shadowRoot.querySelector('[role="status"]');
        this.observer = new MutationObserver(()=>this.announce());
    }
    connectedCallback() {
        this.observer.observe(this, {
            childList: true,
            characterData: true,
            subtree: true
        });
        if (this.ready) {
            this.announce();
            return;
        }
        this.cancel = $6fde75954cba9d3a$var$afterFrames($6fde75954cba9d3a$var$FRAMES, ()=>{
            this.ready = true;
            this.announce();
        });
    }
    disconnectedCallback() {
        this.observer.disconnect();
        this.cancel?.();
    }
    message() {
        return [
            ...this.querySelectorAll($6fde75954cba9d3a$var$MESSAGE)
        ].filter((node)=>node.closest('elm-announcement') === this).map((node)=>node.textContent.trim()).join(' ');
    }
    announce() {
        if (!this.ready) return;
        const message = this.message();
        if (this.region.textContent !== message) this.region.textContent = message;
    }
}
if (!customElements.get('elm-announcement')) customElements.define('elm-announcement', $6fde75954cba9d3a$var$ElmAnnouncement);


//# sourceMappingURL=project.502978bb.js.map
